// Lead capture for every form on the site (contact form, demo requests,
// newsletter). Posts to the GrabNChat public lead-capture API
//   POST {API host}/api/v1/leads/capture   (header X-API-Key: gnc_pub_…)
// which saves the lead straight into the GrabNChat CRM. The gnc_pub_ key
// can only create leads, so it is safe to ship in client-side code.
const API_HOST = (process.env.REACT_APP_PUBLIC_API_URL || "https://backend.grabnchat.com").replace(/\/+$/, "");
const LEADS_API_URL = process.env.REACT_APP_LEADS_API_URL || `${API_HOST}/api/v1/leads/capture`;
const LEADS_API_KEY = process.env.REACT_APP_LEADS_API_KEY || "gnc_pub_cy-sw4mCKOmUwj9UOUCZcpN3Qx-MDVCc";
const TIMEOUT_MS = 15000;

/** UTM parameters from the current URL, so leads keep their campaign. */
function utmParams() {
  try {
    const q = new URLSearchParams(window.location.search);
    const out = {};
    for (const k of ["utm_source", "utm_medium", "utm_campaign"]) {
      const v = q.get(k);
      if (v) out[k] = v;
    }
    return out;
  } catch {
    return {};
  }
}

/**
 * Submit a lead.
 * @param {{name: string, phone?: string, email?: string, message?: string, tags?: string[], _gotcha?: string}} payload
 * @returns {Promise<object>} the API response
 * @throws {Error} with a user-friendly message
 */
export async function captureLead(payload) {
  const body = {
    ...payload,
    source: "website",
    page_url: window.location.href,
    referrer: document.referrer || undefined,
    ...utmParams(),
  };

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  let res;
  try {
    res = await fetch(LEADS_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-API-Key": LEADS_API_KEY },
      body: JSON.stringify(body),
      signal: controller.signal,
    });
  } catch (e) {
    const err = new Error(
      e?.name === "AbortError"
        ? "The request timed out. Please try again."
        : "Could not reach our server. Check your connection and try again.",
    );
    err.kind = "network";
    throw err;
  } finally {
    clearTimeout(timer);
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    let err;
    if (res.status === 429) {
      err = new Error("Too many requests. Please try again in a few minutes.");
      err.kind = "rate_limit";
    } else if (res.status === 422 && data?.detail) {
      // The visitor's input (e.g. invalid email) — they need to fix it.
      err = new Error(String(data.detail).replace(/^./, (c) => c.toUpperCase()));
      err.kind = "validation";
    } else {
      err = new Error("Something went wrong. Please try again.");
      err.kind = "server";
    }
    throw err;
  }
  return data;
}
